// jquery-shim.js
import $ from "jquery";
window.$ = $;
window.jQuery = $;
export default $;
